import React from 'react';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'absolute',
        bottom: 0,
        right: '50px'
    }
  }));  

function ClearBtn(props) {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const states = useSelector(state => {
        return state.globalStates
    })
    const handleClick = (e) => {
        e.preventDefault();
        history.push(`/`)
        const statesToClear = [
            'aon_options',
            'banks',
            'car_brands',
            'bipd_options',
            'car_models',
            'car_years',
            'pa_options',
            'vehicle_types'
        ]
        clearStates(statesToClear);
    }

    const clearStates = (statesToClear) => {
        const stateArr = Object.keys(states);
        stateArr.forEach((state) => {
          if( statesToClear.indexOf(state) === -1 ) {
            dispatch({
              type: `UPDATE_${ state.toUpperCase() }`,
              payload: null
            })
          }
        })
    }
    
    return(
        <div className={ classes.root }>
            <Button 
                onClick={ handleClick }
                variant="outlined">Clear All
            </Button>
        </div>
    )
}

export default ClearBtn;